export default __webpack_public_path__ + "media/images/gallery/12-03a5559317c4a73619f3a82c1384c08d.jpg";